import { FC, useEffect, useState } from "react"
import { ColSize, ContentSection, Form, InputForm, RadioForm, RowSize } from "../../../../../../../shared/components"
import { IntermediaryInformation } from "../../../../../../../shared/interfaces/services/get-producer-information-service"
import { DECISION_TYPE, OPTION_YES_OR_NOT } from "../../../../../../../shared/interfaces";
import { ValidateForm } from "../../../../../../../shared/utils";

interface ElectronicPolicyInfoFormProperties {
    intermediaryInformation:IntermediaryInformation;
}

export const ElectronicPolicyInfoForm: FC<ElectronicPolicyInfoFormProperties> = ({intermediaryInformation}) => {
    const [disableInput, setDisableInput] = useState(false);
    const validateForm = new ValidateForm();


    useEffect(() => {        
        if (intermediaryInformation.polizaElectronica.recibe === DECISION_TYPE.YES) {
            setDisableInput(false);
        }else{
            setDisableInput(true);
        }
    }
    , [intermediaryInformation.polizaElectronica.recibe]);

    const handleChange = (choseOption: string) => {        
        if(choseOption === DECISION_TYPE.NO){
            setDisableInput(true)
        }else{
            setDisableInput(false)
        }
    }

    return (
        <div id="poliza-electronica">
            <ContentSection level='h3' title='Póliza Electrónica'>
                <RowSize>
                    <ColSize size={25}>
                        <RadioForm
                            formProps={{
                                initialValue: intermediaryInformation.polizaElectronica.recibe,
                                label: 'Deseo recibir mis pólizas en PDF diariamente: ',
                                name: 'optionElectronicPolicy',
                            }}
                            options={OPTION_YES_OR_NOT}
                            radioProps={{ onChange: (event) => handleChange(event.target.value) }} 
                        />
                    </ColSize>
                    <ColSize size={25}>
                        <InputForm
                            formProps={{
                                label: 'Ingrese o edite el mail: ',
                                name: 'electronicPolicyMail',
                                rules: validateForm.generateRules({
                                    label: 'Email Recepción',
                                    rules: ['email'],
                                }),
                                initialValue: intermediaryInformation.polizaElectronica.mail
                            }}
                            inputProps={{ placeholder: 'Email para la recepción', disabled: disableInput }}
                        />
                    </ColSize>
                </RowSize>
            </ContentSection>
        </div>
    )
}